/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlayerDataCustomerConfig
 */
export interface PlayerDataCustomerConfig {
    /**
     * 
     * @type {boolean}
     * @memberof PlayerDataCustomerConfig
     */
    allowDeviceTicketScans?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlayerDataCustomerConfig
     */
    claimFormEnabled?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof PlayerDataCustomerConfig
     */
    claimsReservationHostUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlayerDataCustomerConfig
     */
    appHostName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlayerDataCustomerConfig
     */
    emailSender?: string | null;
}

/**
 * Check if a given object implements the PlayerDataCustomerConfig interface.
 */
export function instanceOfPlayerDataCustomerConfig(value: object): value is PlayerDataCustomerConfig {
    return true;
}

export function PlayerDataCustomerConfigFromJSON(json: any): PlayerDataCustomerConfig {
    return PlayerDataCustomerConfigFromJSONTyped(json, false);
}

export function PlayerDataCustomerConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayerDataCustomerConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'allowDeviceTicketScans': json['allowDeviceTicketScans'] == null ? undefined : json['allowDeviceTicketScans'],
        'claimFormEnabled': json['claimFormEnabled'] == null ? undefined : json['claimFormEnabled'],
        'claimsReservationHostUrl': json['claimsReservationHostUrl'] == null ? undefined : json['claimsReservationHostUrl'],
        'appHostName': json['appHostName'] == null ? undefined : json['appHostName'],
        'emailSender': json['emailSender'] == null ? undefined : json['emailSender'],
    };
}

export function PlayerDataCustomerConfigToJSON(value?: PlayerDataCustomerConfig | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'allowDeviceTicketScans': value['allowDeviceTicketScans'],
        'claimFormEnabled': value['claimFormEnabled'],
        'claimsReservationHostUrl': value['claimsReservationHostUrl'],
        'appHostName': value['appHostName'],
        'emailSender': value['emailSender'],
    };
}

